/** Shared SPA path normalization for sidebar + post-login redirects. */
import type { SessionPayload } from "./api";
export function spaPathFromBackendHref(href: string): string {
  const h = `${href || ""}`.trim();
  if (!h) return "/";
  try {
    if (/^https?:\/\//i.test(h)) {
      const u = new URL(h);
      const path = `${u.pathname}${u.search}`;
      return path.length ? path : "/";
    }
  } catch {
    /* ignore */
  }
  return h.startsWith("/") ? h : `/${h}`;
}
/** Flatten backend navigation to the first sidebar link (preferred default when dashboard is off-ACL). */
export function firstNavigationHrefFromPayload(nav: SessionPayload["navigation"]): string | null {
  if (!Array.isArray(nav)) return null;
  for (const sec of nav) {
    const links = sec.links;
    if (!Array.isArray(links)) continue;
    for (const lnk of links) {
      const raw = `${lnk.href || ""}`.trim();
      if (!raw) continue;
      return spaPathFromBackendHref(raw);
    }
  }
  return null;
}
